/* Makerz v2 – kollektionsfiltre, sortering, mobil filter-panel. Kun i ikke-publiceret kopi. */
(function(){
  var root=document.querySelector('[data-mkz2-coll]');
  if(root){
    var form=root.querySelector('[data-mkz2-filters]');
    var grid=root.querySelector('[data-mkz2-grid]');
    var cards=grid?[].slice.call(grid.querySelectorAll('.mkz2-card')):[];
    var promos=grid?[].slice.call(grid.querySelectorAll('[data-mkz2-promo]')):[];
    var empty=root.querySelector('[data-mkz2-empty]');
    var activeBox=root.querySelector('[data-mkz2-active]');
    var groups=['hud','skin','type'];
    var aliases={hud:'hud',hudproblem:'hud',skin:'hudtype',type:'type'};
    function selected(){
      var s={};
      groups.forEach(function(g){ s[g]=[].slice.call(form.querySelectorAll('input[name="'+g+'"]:checked')).map(function(i){return i.value;}); });
      return s;
    }
    function labelFor(g,v){ var i=form.querySelector('input[name="'+g+'"][value="'+v+'"]'); return i?i.nextElementSibling.textContent:v; }
    function apply(push){
      var s=selected(), n=0, any=false;
      groups.forEach(function(g){ if(s[g].length) any=true; });
      cards.forEach(function(c){
        var ok=groups.every(function(g){
          if(!s[g].length) return true;
          var have=(c.getAttribute('data-'+g)||'').split(' ');
          return s[g].some(function(v){ return have.indexOf(v)>-1; });
        });
        c.hidden=!ok; if(ok) n++;
      });
      promos.forEach(function(p){ p.hidden=any; });
      if(empty) empty.hidden=n>0;
      root.querySelectorAll('[data-mkz2-count-total]').forEach(function(e){ e.textContent=n; });
      var total=0;
      groups.forEach(function(g){
        var e=root.querySelector('[data-mkz2-count="'+g+'"]'); if(e) e.textContent=s[g].length?' ('+s[g].length+')':'';
        total+=s[g].length;
      });
      var an=root.querySelector('[data-mkz2-active-n]'); if(an){ an.textContent=total?'('+total+')':''; an.hidden=!total; }
      if(activeBox){
        activeBox.innerHTML='';
        groups.forEach(function(g){ s[g].forEach(function(v){
          var b=document.createElement('button'); b.type='button'; b.className='mkz2-pill'; b.textContent=labelFor(g,v)+' ×';
          b.addEventListener('click',function(){ var i=form.querySelector('input[name="'+g+'"][value="'+v+'"]'); if(i){i.checked=false; apply(true);} });
          activeBox.appendChild(b);
        }); });
        activeBox.hidden=!total;
      }
      if(push){
        try{
          var u=new URL(location.href);
          groups.forEach(function(g){ var k=g==='skin'?'hudtype':g; if(s[g].length) u.searchParams.set(k,s[g].join(',')); else u.searchParams.delete(k); });
          history.replaceState({},'',u);
        }catch(e){}
      }
    }
    if(form){
      form.addEventListener('change',function(){ apply(true); });
      // init from URL (?hud=roedmende,toer&hudtype=sart&type=olie)
      try{
        var u=new URL(location.href);
        [['hud','hud'],['hudtype','skin'],['skin','skin'],['type','type']].forEach(function(pair){
          var val=u.searchParams.get(pair[0]); if(!val) return;
          val.split(',').forEach(function(v){ var i=form.querySelector('input[name="'+pair[1]+'"][value="'+v+'"]'); if(i) i.checked=true; });
        });
      }catch(e){}
      apply(false);
      root.querySelectorAll('[data-mkz2-reset]').forEach(function(b){ b.addEventListener('click',function(){ form.querySelectorAll('input:checked').forEach(function(i){i.checked=false;}); apply(true); }); });
      // only one dropdown open at a time (desktop)
      var dds=[].slice.call(form.querySelectorAll('[data-mkz2-dd]'));
      dds.forEach(function(d){ d.addEventListener('toggle',function(){ if(d.open && window.innerWidth>989){ dds.forEach(function(o){ if(o!==d) o.open=false; }); } }); });
      document.addEventListener('click',function(e){ if(window.innerWidth>989 && !form.contains(e.target)) dds.forEach(function(o){o.open=false;}); });
      // mobile panel
      var openBtn=root.querySelector('[data-mkz2-filter-open]');
      function setOpen(o){ form.classList.toggle('is-open',o); document.documentElement.classList.toggle('mkz2-lock',o); if(openBtn) openBtn.setAttribute('aria-expanded',o?'true':'false'); if(o && window.innerWidth<=989) dds.forEach(function(d){d.open=true;}); }
      if(openBtn) openBtn.addEventListener('click',function(){ setOpen(true); });
      root.querySelectorAll('[data-mkz2-filter-close]').forEach(function(b){ b.addEventListener('click',function(){ setOpen(false); var bar=document.getElementById('mkz2-bar'); if(bar && window.innerWidth<=989) bar.scrollIntoView({behavior:'smooth'}); }); });
      document.addEventListener('keydown',function(e){ if(e.key==='Escape') setOpen(false); });
    }
    var sort=root.querySelector('[data-mkz2-sort]');
    if(sort) sort.addEventListener('change',function(){ var u=new URL(location.href); u.searchParams.set('sort_by',sort.value); u.searchParams.delete('page'); location.href=u.toString(); });
  }
})();
/* Makerz perf: quick add-JS loades først ved brug/idle; 2. kortbillede først ved hover */
(function(){
  var qaDone=false;
  function loadQA(){ if(qaDone||!window.mkzQA||!document.querySelector('[data-skqa]'))return; qaDone=true; var s=document.createElement('script'); s.src=window.mkzQA; s.async=true; document.head.appendChild(s); }
  ['pointerover','focusin','touchstart'].forEach(function(ev){ document.addEventListener(ev,function(e){ if(e.target.closest&&e.target.closest('[data-skqa]')) loadQA(); },{passive:true}); });
  document.addEventListener('click',function(e){ var r=e.target.closest&&e.target.closest('[data-skqa]'); if(r&&!window.__skQuickAddLoaded){ e.preventDefault(); var t=e.target; loadQA(); var n=0,iv=setInterval(function(){ if(window.__skQuickAddLoaded||++n>40){ clearInterval(iv); if(window.__skQuickAddLoaded) t.click(); } },50); } },true);
  window.addEventListener('load',function(){ (window.requestIdleCallback||function(f){setTimeout(f,2500)})(loadQA,{timeout:4000}); });
  if(window.matchMedia&&matchMedia('(hover:hover) and (pointer:fine)').matches){
    document.addEventListener('pointerover',function(e){ var m=e.target.closest&&e.target.closest('.mkz2-card__media.has-2'); if(!m||m._mk)return; m._mk=1; var i=m.querySelector('img[data-src]'); if(!i)return; if(i.dataset.srcset)i.srcset=i.dataset.srcset; i.onload=function(){m.classList.add('mk-ld')}; i.src=i.dataset.src; i.removeAttribute('data-src'); },{passive:true});
  }
})();
